module.exports = __webpack_public_path__ + "static/media/ongoint-feedback.ff2adbe4.svg";